import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { Button, TextField, Typography, Box, CircularProgress, Switch, Grid, FormControl, Alert, Tab, Tabs, Dialog, DialogTitle, IconButton, Divider, DialogContent, DialogActions, MenuItem, Radio, RadioGroup, Select, FormControlLabel, Avatar ,} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { IconAlertTriangle, IconCheck, IconX } from "@tabler/icons-react";
import PageContainer from "./Pagecontainer";
import ScheduleDemo from "./demo";



const Questions = () => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const navigate = useNavigate();
    const steps = ["Bussiness Overview", "Product or Service Offering", "Statement of Problem", "Proposed Solutions", "Market Analysis"];
    const { register, handleSubmit, formState: { errors }, trigger, clearErrors, setValue, reset, watch } = useForm();
    const { register: airegister, handleSubmit: handleai, formState: { errors: aierror }, trigger: aitrigger, setValue: setaiValue } = useForm();
    const { register: registerproject, handleSubmit: handleProject, setValue:setProjectValue, formState: { errors: projectErrors }, trigger: projecttrigger } = useForm();
    const [questions, setquestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [Showform, setshowForm] = useState(true);
    const [Showquestionform, setShowquestionform] = useState(false);
    const [projectid, setProjectid] = useState('');
    const [error, setError] = useState(null);
    const [Url, setUrl] = useState("")
    const [activeTab, setActiveTab] = useState(0);
    const [BusinessName, setBusinessName] = useState('')
    const [Language, setLanguage] = useState('')
    const [successpopup, setsuccesspopup] = useState(false)
    const userinfo = JSON.parse(sessionStorage.getItem('user-info'));
    const [Errorpopup, setErrorpopup] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [toggleState, setToggleState] = useState(false);
    const [fileName, setFileName] = useState("");

    const [logoBase64, setLogoBase64] = useState("");
    const location = useLocation();
    const[projectName,setprojectName]= useState('')
    const [logo,setLogo]= useState(null)
    const { projectId, mode} = location.state || {};
    const [logoPreiew,setLogoPreview] = useState('')
    const [logoModified, setLogoModified] = useState(false);
 const [setupData, setSetupData] = useState({});


    console.log(projectId, projectName, mode, logo);
useEffect(() => {
  getSetupData();
}, []);

const getSetupData = async () => {
  try {
    const response = await axios.get('/apiV1/set-up/');
    if (response.status === 200) {
      setSetupData(response.data);
    }
  } catch (err) {
    console.log(err?.response?.data?.message);
  }
};

console.log(setupData);
   useEffect(() => {
    // const convertImageToBase64 = async (url) => {
    //     try {
    //         const response = await fetch(url);
    //         const blob = await response.blob();

    //         return new Promise((resolve, reject) => {
    //             const reader = new FileReader();
    //             reader.onloadend = () => resolve(reader.result);
    //             reader.onerror = reject;
    //             reader.readAsDataURL(blob);
    //         });
    //     } catch (error) {
    //         console.error("Error converting image to base64:", error);
    //         return null;
    //     }
    // };

    
    
      

    const getProjectDetails = async () => {
        try {
            const response = await axios.get(`/apiV1/projects/${projectId}/`);
            if (response.status === 200) {
                const data = response.data;
                setprojectName(data.business_name);
                setProjectValue("businessName", data.business_name);
                setLogoPreview(data.logo_url || "");
                setFileName(data.logo_url ? data.logo_url.split("/").pop() : "No file chosen");

                // Convert to base64 only if logo_url exists
                // if (data.logo_url) {
                //     const base64 = await convertImageToBase64(data.logo_url);
                //     if (base64) setLogoBase64(base64);
                // }
                 setLogoModified(false);
            }
        } catch (error) {
            console.error("Error fetching project:", error);
        }
    };

    if (mode === "edit") {
        getProjectDetails();
    } else {
        // Reset all fields in non-edit mode
        setLogoBase64("");
        setLogoPreview("");
        setProjectValue("businessName", "");
        setprojectName("");
        setFileName("");
          setLogoModified(false);
    }
}, [mode, projectId]);

   // Update the updateProject function
const updateProject = async (data) => {
    try {
        let req = {
            business_name: data.businessName,
        };

        // Only include logo_pic if it has been modified
        if (logoModified) {
            req.logo_pic = logoBase64; // This will be empty string if logo was removed
        }

        const resp = await axios.patch(`/apiV1/projects/${projectId}/`, req);
        if (resp.status === 200) {
            navigate('/dashboard');
        }
    } catch (error) {
        console.log(error);
    }
};

    useEffect(() => {
        if (questions.length > 0) {
            const question11 = questions.find(q => q.id === 11);
            if (question11) {
                setValue("11", "We are in Pre Revenue");
            }
        }
    }, [questions]);
        
    const getQuestions = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/apiV1/questions/');
            console.log(response);
            if (response.status === 200) {
                setquestions(response.data);
                setLoading(false);

            }
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);

        }
    }


    const projectSubmit = async (data) => {
        setBusinessName(data.businessName)
        setLanguage(data.language)
        console.log(data.language, 'language')
        if (data?.url1) {
            setUrl(data.url1);
            setaiValue("suggestionurl", data.url1);
        }
        try {
            setLoading1(true);
            let req = {
                url: data.url1,
                business_name: data.businessName,
                // language: data.language
            };
            const response = await axios.post('/apiV1/projects/', req);
            console.log(response);
            if (response.status === 200) {
                setLoading1(false);
                setShowquestionform(true);
                setshowForm(false);
            }

        } catch (error) {
            console.log(error);
            setError(error.response.data.message);
            setLoading1(false);

        }
    }

    const CheckSubcriptionai = async (data) => {
        setLoading(true);
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
            }
            // const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/update-customer-subs/?user_id=${userinfo.id}&no_total_ai_suggestions=${1}`,config2);
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL2}/apiV1/update-customer-subs/?user_id=${userinfo.id}&no_total_ai_suggestions=${1}`,
                {},
                config2
            );
            if (response.status === 200) {
                aisuggestion(data)
            }
        }
        catch (error) {
            setErrorpopup(true)
            setLoading(false);
            setErrorMessage("You have exceeded the limit of AI suggestions. Please upgrade your plan to get more suggestions.")
            console.log(error)
        }
    }
    const aisuggestion = async (data) => {
        try {
            if (!Url || Url !== data.suggestionurl) {
                setUrl(data.suggestionurl);
            }
            setLoading(true);
            setError("");
            let req = {
                url: data ? data.suggestionurl : Url,
                language: Language,
            };
            const response = await axios.post(`/apiV1/aisuggestion/`, req);
            console.log(response);

            if (response.status === 200) {
                setLoading(false);
                const suggestionsMap = {};
                Object.entries(response.data.message).forEach(([key, suggestion]) => {
                    const index = parseInt(key, 10);
                    suggestionsMap[index] = suggestion;
                    setValue(String(index), suggestion);
                    clearErrors(String(index));
                });

            }

        } catch (error) {
            console.log(error);
            reset()
            setError(error.response.data.message)
            setLoading(false);
        }
    };

    useEffect(() => {
        if (Url) {
            aisuggestion({ suggestionurl: Url });
        }
    }, [Url]);
    const questionans = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/apiV1/project-responses/responses/?project_id=${id}`);

            if (response.status === 200) {
                setLoading(false);
                setshowForm(false);
                setShowquestionform(true);
                const answersMap = {};
                const questionData = response.data.data;

                if (questionData) {
                    questionData.forEach((item, index) => {
                        const questionIndex = index;
                        const answer = item.answer;
                        answersMap[questionIndex] = answer;
                        setValue(String(questionIndex), answer);
                    });
                    setquestions(questionData.map(item => item.question));
                } else {
                    console.log('No question data available in response.');
                }

            }
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        try {
            setLoading(true);
             if (toggleState === false) {
                data["11"] = "We are in Pre Revenue";
            }
            const updatedData = {
                ...data,
                url: Url,
                business_name: BusinessName,
                language: Language,
                is_pre_revenue: !toggleState,
                logo_pic: logoBase64,
            };

            const response = await axios.post(`/apiV1/project-responses/responsesv3/`, updatedData);
            console.log(response);
            if (response.status == 200) {
                setsuccesspopup(true)
                setProjectid(response.data.project_id)
                setLoading(false);
                // navigate(`/documents?id=${projectid}`);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            setError(error.response.data.message)
        }
    };
    const CheckSubcriptionPro = async (data) => {
        try {
            setLoading1(true);
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
            }
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL2}/apiV1/update-customer-subs/?user_id=${userinfo.id}&no_total_projects=${1}`,
                {},
                config2
            );
            if (response.status === 200) {
                onSubmit(data)
                setLoading1(false);
            }
        }
        catch (error) {
            setErrorpopup(true)
            setErrorMessage("You have exceeded the limit of projects. Please upgrade your plan to create more projects.")
            setLoading1(false);
            console.log(error)
        }
    }

    useEffect(() => {
        if (id) {
            questionans();
        }
        else {
            getQuestions()
        }
    }, [id]);

    // const getStepContent = (step) => {
    //     const questionsPerStep = 2;
    //     const startIndex = step * questionsPerStep;
    //     const stepQuestions = questions.slice(startIndex, startIndex + questionsPerStep);

    //     return (
    //         <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
    //             {loading ? (
    //                 <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", maxHeight: "40vh" }}>
    //                     <CircularProgress />
    //                 </Box>
    //             ) : (
    //                 stepQuestions.map((question, index) => {
    //                     const isRequired = question.is_require;
    //                     const questionId = String(question.id);
    //                     return (
    //                         <div key={questionId}>
    //                             <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
    //                                 {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
    //                             </Typography>
    //                             <textarea
    //                                 style={{
    //                                     width: "100%",
    //                                     padding: "10px",
    //                                     borderRadius: "8px",
    //                                     border: "1px solid #ccc",
    //                                     fontSize: "14px",
    //                                     fontFamily: "Arial",
    //                                 }}
    //                                 rows={4}
    //                                 {...register(questionId, { required: isRequired ? "This field is required" : false ,
    //                                     pattern: {
    //                                         value: /^(?!^\s)/,
    //                                         message: "Answers cannot start with a space"
    //                                     }
    //                                 })}
    //                                 onKeyUp={() => trigger(questionId)}
    //                             />
    //                             {errors?.[questionId] && (
    //                                 <Typography color="error" variant="body2">
    //                                     {errors[questionId]?.message}
    //                                 </Typography>
    //                             )}
    //                         </div>
    //                     );
    //                 })
    //             )}
    //         </Box>

    //     );
    // };
   
  
 const [UploadError,setUploadError] = useState('')
    const handleFileChange = (e) => {
        setUploadError('')
        const file = e.target.files[0];
        if (file) {
            const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];

            // Check file type
            if (!allowedTypes.includes(file.type)) {
                setUploadError('Only PNG, JPG, JPEG, and GIF files are allowed!')
                setFileName('')
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                setUploadError("File size should not exceed 5MB!");
                setFileName('')
                return; // Stop further processing
            }
            setFileName(file.name);

            const reader = new FileReader();
            reader.onloadend = () => {
                setLogoBase64(reader.result);
                setLogoPreview(reader.result)
                  setLogoModified(true); // Mark as modified
            };
            reader.readAsDataURL(file);
        }
    };

    const removeFile = () => {

        setFileName("");
        setLogoBase64("");
        setLogoPreview('');
        setLogoModified(true); 
    };

    const getStepContent = (step) => {
        const questionsPerStep = 2;
        const totalQuestions = questions.length;

        const totalSteps = Math.ceil((totalQuestions - 3) / questionsPerStep) + 1; // All but last step has 2, last step has 3
        const isLastStep = step === totalSteps - 1;

        const startIndex = isLastStep
            ? totalQuestions - 3
            : step * questionsPerStep;
        const endIndex = isLastStep
            ? totalQuestions
            : startIndex + questionsPerStep;

        const stepQuestions = questions.slice(startIndex, endIndex);

        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", maxHeight: "40vh", display: "none" }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {stepQuestions.map((question) => {
                            const isRequired = question.is_require;
                            const questionId = String(question.id);

                            if (question.id === 11) {
                                return (
                                    <div key={questionId}>

                                        <div >
                                            <Typography variant="subtitle1" sx={{ fontWeight: 500, marginBottom: '5px' }}>
                                                Is the product currently generating revenue streams?
                                            </Typography>

                                            <FormControl component="fieldset" size="small" sx={{ minWidth: 80 }}>
                                                <RadioGroup
                                                    row
                                                    value={toggleState.toString()} // Convert boolean to string for radio value matching
                                                    onChange={(e) => {
                                                        const isYes = e.target.value === "true";
                                                        setToggleState(isYes);

                                                        if (!isYes) {
                                                            // User selected "No" - set pre-revenue message
                                                            setValue(questionId, "We are in Pre Revenue");
                                                            clearErrors(questionId); // Clear any validation errors
                                                        } else {
                                                            // User selected "Yes" - clear the field so they can enter their own answer
                                                            setValue(questionId, "");
                                                        }
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="true"
                                                        control={<Radio size="small" />}
                                                        label="Yes"
                                                    />
                                                    <FormControlLabel
                                                        value="false"
                                                        control={<Radio size="small" />}
                                                        label="No"
                                                    />
                                                </RadioGroup>

                                            </FormControl>
                                        </div>


                                        {toggleState && (
                                            <>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                    {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
                                                </Typography>
                                                <textarea
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px",
                                                        borderRadius: "8px",
                                                        border: "1px solid #ccc",
                                                        fontSize: "14px",
                                                        fontFamily: "Arial",
                                                    }}
                                                    rows={4}
                                                    {...register(questionId, {
                                                        required: isRequired ? "This answer is required" : false,
                                                        pattern: {
                                                            value: /^(?!^\s)/,
                                                            message: "Answers cannot start with a space",
                                                        },
                                                    })}
                                                    onKeyUp={() => trigger(questionId)}
                                                />
                                                {errors?.[questionId] && (
                                                    <Typography color="error" variant="body2">
                                                        {errors[questionId]?.message}
                                                    </Typography>
                                                )}
                                            </>
                                        )}
                                    </div>
                                );
                            }

                            return (
                                <div key={questionId}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                        {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
                                    </Typography>
                                    <textarea
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc",
                                            fontSize: "14px",
                                            fontFamily: "Arial",
                                        }}
                                        rows={4}
                                        {...register(questionId, {
                                            required: isRequired ? "This answer is required" : false,
                                            pattern: {
                                                value: /^(?!^\s)/,
                                                message: "Answers cannot start with a space",
                                            },
                                        })}
                                        onKeyUp={() => trigger(questionId)}
                                    />
                                    {errors?.[questionId] && (
                                        <Typography color="error" variant="body2">
                                            {errors[questionId]?.message}
                                        </Typography>
                                    )}
                                </div>
                            );
                        })
                        }</>
                )
                }
            </Box>
        );
    };


    const handleNext = async (event) => {
        event.preventDefault();
        const isValid = await trigger();
        if (!isValid) return;
        setActiveTab((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveTab((prev) => prev - 1);
    };

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const [suberrorsubscription, setErrorsubscription] = useState(false);
    const handleplancheck = async () => {
        setLoading(true);
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/update-customer-subs/?user_id=${userinfo.id}`, config2);
            if (response.status === 200) {
                setErrorsubscription(false);
                setLoading(false);
            }
        } catch (error) {
            console.log(error?.response?.data?.message);
            setErrorsubscription(error?.response?.data?.message)
            setLoading(false);
        }
    }
    useEffect(() => {
        handleplancheck();
    }, []);
    return (
        <>
            <PageContainer title="SmartInvestorDeck | Create Business Ideas">
                <ScheduleDemo showBanner={true} />
                {loading && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh",
                            width: "100vw",
                            position: "fixed",
                            top: 0,
                            left: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            zIndex: 9999,
                        }}
                    >
                        <BeatLoader color=" #07659c" size={20} />
                    </Box>
                )}
                <Grid container-fluid justifyContent="center" alignItems="center" >
                    <Grid item xs={12} sm={10} md={8} lg={6} sx={{ width: "100%", margin: "auto" }}>
                        {Showform &&
                            <form onSubmit={handleProject(projectSubmit)}>
                                <Box
                                    sx={{
                                        border: "1px solid #3d3b3b17",
                                        flexDirection: "column",
                                        p: 4,
                                        borderRadius: 2,
                                        width: { xs: "100%", sm: "70%" },
                                        justifyContent: "center",
                                        margin: "auto",
                                        mt: 10,
                                    }}
                                >
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", }}>
                                        <Box sx={{ alignItems: "center", width: "100%" }}>
                                            <Typography variant="h3" align="center" sx={{ fontWeight: 550, background: 'linear-gradient(180deg, var(--primary-black), var(--primary-red))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Create Business Ideas</Typography>
                                            <Typography variant="h6" align="center" sx={{ maxWidth: "100%", fontWeight: 100, textAlign: "center", justifyContent: "center", mt: 2, mb: 2 }}>
                                                Enter your business website URL to auto-fill details, or skip and enter them manually.
                                                {/* If you have a website URL for your business, you can mention it here, and all the required questions for document generation will be answered automatically. If not, you can skip this step and enter the details manually. */}
                                            </Typography>
                                        </Box>
                                        <FormControl variant="standard" margin="normal" sx={{ width: { xs: "100%", sm: "50%" } }}>
                                            <Typography variant="body2" gutterBottom>Enter Business Name <span style={{ color: "red", fontSize: "18px" }}>*</span></Typography>
                                            <TextField
                                                fullWidth
                                                placeholder="Enter Business Name"
                                                inputProps={{ maxLength: 50 }}
                                                {...registerproject("businessName", {
                                                    required: "Business name is required",
                                                    pattern: {
                                                        value: /^(?!\s).*$/,
                                                        message: "Business name cannot begin with a space."
                                                    }
                                                })}
                                                error={!!projectErrors.businessName}
                                                helperText={projectErrors.businessName?.message}
                                                onKeyUp={() => { projecttrigger("businessName"); setError("") }}
                                            />
                                        </FormControl>
                                            { mode !== 'edit' && (
                                                <FormControl variant="standard" margin="normal" sx={{ width: { xs: "100%", sm: "50%" } }}>
                                                    <Typography variant="body2" gutterBottom>Enter website URL</Typography>
                                                    <TextField
                                                        fullWidth
                                                        placeholder="Enter website URL"
                                                        {...registerproject("url1", {
                                                            pattern: {
                                                                value: /^https?:\/\/(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}([\/\w\.-]*)*\/?$/,
                                                                message: "Enter a valid website URL (e.g., https://example.com)",
                                                            },
                                                        })}
                                                        error={!!projectErrors.url1}
                                                        helperText={projectErrors.url1?.message}
                                                        onKeyUp={() => { projecttrigger("url1"); setError("") }}
                                                    />

                                                </FormControl>
                                                )
                                            }

                                             { mode !== 'edit' && (
                                        <FormControl variant="standard" margin="normal" sx={{ width: { xs: "100%", sm: "50%" } }}>
                                            <Typography variant="body2" gutterBottom>Select Language</Typography>
                                            <Select
                                                variant="outlined"
                                                fullWidth
                                                defaultValue="English"
                                                {...registerproject("language", { required: "Language selection is required" })}
                                                error={!!projectErrors.language}
                                                sx={{
                                                    maxHeight: "40px",
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300, // Set dropdown max height
                                                            overflowY: "auto",
                                                        },
                                                    },
                                                }}
                                            >
                                                <MenuItem value="Arabic">Arabic (العربية)</MenuItem>
                                                <MenuItem value="Assamese">Assamese (অসমীয়া)</MenuItem>
                                                <MenuItem value="Bengali">Bengali (বাংলা)</MenuItem>
                                                <MenuItem value="Chinese">Chinese (中文)</MenuItem>
                                                <MenuItem value="Dutch">Dutch (Nederlands)</MenuItem>
                                                <MenuItem value="English">English</MenuItem>
                                                <MenuItem value="Filipino">Filipino</MenuItem>
                                                <MenuItem value="French">French (Français)</MenuItem>
                                                <MenuItem value="German">German (Deutsch)</MenuItem>
                                                <MenuItem value="Greek">Greek (Ελληνικά)</MenuItem>
                                                <MenuItem value="Gujarati">Gujarati (ગુજરાતી)</MenuItem>
                                                <MenuItem value="Hebrew">Hebrew (עברית)</MenuItem>
                                                <MenuItem value="Hindi">Hindi (हिन्दी)</MenuItem>
                                                <MenuItem value="Indonesian">Indonesian (Bahasa Indonesia)</MenuItem>
                                                <MenuItem value="Italian">Italian (Italiano)</MenuItem>
                                                <MenuItem value="Japanese">Japanese (日本語)</MenuItem>
                                                <MenuItem value="Kannada">Kannada (ಕನ್ನಡ)</MenuItem>
                                                <MenuItem value="Korean">Korean (한국어)</MenuItem>
                                                <MenuItem value="Malay">Malay (Bahasa Melayu)</MenuItem>
                                                <MenuItem value="Malayalam">Malayalam (മലയാളം)</MenuItem>
                                                <MenuItem value="Marathi">Marathi (मराठी)</MenuItem>
                                                <MenuItem value="Persian">Persian (فارسی)</MenuItem>
                                                <MenuItem value="Polish">Polish (Polski)</MenuItem>
                                                <MenuItem value="Portuguese">Portuguese (Português)</MenuItem>
                                                <MenuItem value="Punjabi">Punjabi (ਪੰਜਾਬੀ)</MenuItem>
                                                <MenuItem value="Russian">Russian (Русский)</MenuItem>
                                                <MenuItem value="Spanish">Spanish (Español)</MenuItem>
                                                <MenuItem value="Swedish">Swedish (Svenska)</MenuItem>
                                                <MenuItem value="Tamil">Tamil (தமிழ்)</MenuItem>
                                                <MenuItem value="Telugu">Telugu (తెలుగు)</MenuItem>
                                                <MenuItem value="Thai">Thai (ไทย)</MenuItem>
                                                <MenuItem value="Turkish">Turkish (Türkçe)</MenuItem>
                                                <MenuItem value="Urdu">Urdu (اردو)</MenuItem>
                                                <MenuItem value="Vietnamese">Vietnamese (Tiếng Việt)</MenuItem>


                                            </Select>
                                            {projectErrors.language && (
                                                <Typography variant="body2" color="error">
                                                    {projectErrors.language.message}
                                                </Typography>
                                            )}
                                        </FormControl>
                                             )}

                                        <FormControl disabled={setupData.is_subscribed === false}  variant="standard" margin="normal" sx={{ width: { xs: "100%", sm: "50%" } }} required >
                                            <Typography variant="body2" gutterBottom mb={1}>
                                                Upload Logo
                                            </Typography>

                                            <Button variant="outlined" component="label"
                                            //  disabled={setupData.is_subscribed === false}
                                                onClick={(e) => {
                                                    if (setupData.is_subscribed === false) {
                                                        e.preventDefault();
                                                         setErrorMessage('Please subscribe to upload a logo.') 
                                                         setErrorpopup(true) 
                                                    }
                                                }}>
                                                Choose File
                                                <input
                                                    type="file"
                                                     accept=".png, .jpg, .jpeg"
                                                    hidden
                                                    onChange={handleFileChange}
                                                />
                                            </Button>

                                            {fileName && (
                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                                                    <Avatar
                                                        // src={mode === 'edit' ? logo : logoBase64}
                                                        src={logoPreiew}
                                                        alt="Project Logo"
                                                        sx={{
                                                            width: 48,
                                                            height: 48,
                                                            flexShrink: 0,
                                                            mb: 2,
                                                            border:'solid 1px #cfc6c6ff'
                                                        }}
                                                    >
                                                    </Avatar>

                                                <Box sx={{ display: "flex", alignItems: "center", }}>
                                                    <Typography variant="body2">{fileName}</Typography>
                                                    {fileName !== "No file chosen" ? <IconButton size="small" onClick={removeFile} sx={{ ml: 1 }}>
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>:""}
                                                </Box>
                                                </Box>
                                            )}
                                            
                                            
                                        </FormControl>
                                        {UploadError &&
                                        <Typography sx={{color:"red"}}>{UploadError}</Typography>}
                                        <Box sx={{ mt: 2 }}>
                                            {error && <Alert severity="error">{error}</Alert>}
                                            {suberrorsubscription && mode !== 'edit' && (
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                                    <Alert severity="error">
                                                        {suberrorsubscription}
                                                    </Alert>
                                                    <Button onClick={() => navigate('/plans')} className="button2" sx={{ mt: 1 }}>
                                                        Upgrade Now
                                                    </Button>
                                                </Box>

                                            )}
                                        </Box>

                                        
                                    </Box>

                                    {mode === "edit" ||!suberrorsubscription ?(
                                        <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
                                            <Button type="submit" variant="outlined" color="warning" sx={{ mt: 2, backgroundColor: "#c72e33", border: "none" }} disabled={loading1} onClick={() => { { setshowForm(false); navigate('/dashboard') } }}>
                                                Cancel
                                            </Button>
                                        <Button
                                            type={mode === "edit" ? "button" : "submit"} 
                                            variant="outlined"
                                            sx={{ mt: 2 }}
                                            className="button2"
                                            disabled={loading1}
                                            onClick={mode === "edit" ? handleProject((data) => updateProject(data)) : undefined} 
                                        >
                                            {loading1 ? (<BeatLoader size={24} color="#fff" />) : mode === "edit" ? "Update" : "Next"}
                                        </Button>
                                        </Box>
                                    ) : null}
                                </Box>
                            </form>}
                        {Showquestionform &&
                            <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs={12} sm={10} md={12}>
                                    <Grid container justifyContent="center" alignItems="center">
                                        <Grid item xs={12} md={3}>
                                            <Box sx={{ fontSize: "30px", fontWeight: "bold" }}>
                                                Create Business Idea
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={8} sx={{ mt: 2 }}>
                                            <Tabs value={activeTab} onChange={handleChange} variant="fullWidth" indicatorColor="transparent" sx={{ width: "100%" }}>
                                                {steps.map((label, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}
                                                    >
                                                        <Typography variant="caption" sx={{ fontWeight: 600, color: "#000", textAlign: "start" }}>
                                                            Step {index + 1}
                                                        </Typography>
                                                        <Tab
                                                            label={label}
                                                            sx={{
                                                                borderTop: 3,
                                                                mt: 1,
                                                                borderColor: activeTab >= index ? "green" : "gray",
                                                                textTransform: "none",
                                                                fontSize: "14px"
                                                            }}
                                                        />
                                                    </Box>
                                                ))}
                                            </Tabs>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* Input Field & Get Suggestions Button */}
                                <Grid item xs={12} sm={10} md={10}>
                                    <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mt: 2 }}>
                                        <Box component="form" onSubmit={handleai(aisuggestion)} sx={{ display: "flex", gap: 2 }}>
                                            <TextField
                                                placeholder="Enter URL to get Suggestions"
                                                sx={{ width: "300px" }}
                                                {...airegister("suggestionurl", {
                                                    required: "URL is required",
                                                    pattern: {
                                                        value: /^(https:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/,
                                                        message: "Invalid url address",
                                                    },
                                                })}

                                                error={!!aierror?.suggestionurl}
                                                helperText={aierror?.suggestionurl?.message}
                                                onKeyUp={() => aitrigger("suggestionurl")}
                                                disabled={loading}
                                            />
                                            <Button
                                                disabled={loading}
                                                variant="contained"
                                                type="submit"
                                                sx={{ height: "40px", border: "none" }}
                                                className="button2"
                                            >
                                                Get Suggestions
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Box sx={{ mt: 2 }}>
                                        {error && <Alert severity="error">{error}</Alert>}
                                    </Box>

                                    {/* Step Content */}
                                    <Box sx={{ mt: 4 }}>
                                        {Showquestionform &&
                                            <><form onSubmit={handleSubmit(CheckSubcriptionPro)}>
                                                {getStepContent(activeTab)}

                                                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
                                                    <Button disabled={activeTab === 0 || loading} onClick={handleBack} variant="contained" color="primary" sx={{ border: "none" }}>
                                                        Previous
                                                    </Button>
                                                    {activeTab === steps.length - 1 ? (
                                                        <Button type="submit" variant="contained" color="primary" disabled={loading || loading1} sx={{ border: "none" }}>
                                                            Submit
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            variant="contained"
                                                            className="button2"
                                                            onClick={handleNext}
                                                            disabled={loading}
                                                            type="button"
                                                            sx={{ border: "none" }}
                                                        >
                                                            Next
                                                        </Button>
                                                    )}
                                                </Box>
                                            </form>
                                            </>
                                        }
                                    </Box>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Dialog open={successpopup} fullWidth onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setsuccesspopup(false);
                    }
                }}
                    disableEscapeKeyDown>
                    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        Success
                        {/* <IconButton onClick={() => setsuccesspopup(false)}>
                        <IconX size={24} />
                    </IconButton> */}
                    </DialogTitle>

                    <Divider />

                    <DialogContent sx={{ textAlign: "center" }}>
                        <Box sx={{ textAlign: "center", mb: 2 }}>
                            <IconButton sx={{ backgroundColor: "#e6f4ea", padding: 3, "&:hover": { backgroundColor: "#c3e6cb" } }}>
                                <IconCheck color="#28a745" size={50} />
                            </IconButton>
                        </Box>
                        <Typography variant="h6" sx={{ color: "#000", fontWeight: "bold" }}>
                            Successfully submitted!<br /> Your project has been created successfully.
                        </Typography>
                    </DialogContent>

                    <Divider />

                    <DialogActions sx={{ justifyContent: "flex-end" }}>
                        <Button onClick={() => { setsuccesspopup(false); navigate(`/documents?id=${projectid}&name=${BusinessName}`) }} color="primary" variant="contained">
                            Okay
                        </Button>
                    </DialogActions>
                </Dialog>
            </PageContainer>
            <Dialog
                open={Errorpopup}
                onClose={() => setErrorpopup(false)}
                aria-labelledby="error-dialog-title"
                aria-describedby="error-dialog-description"
                PaperProps={{
                    sx: { borderRadius: "16px", padding: "16px" },
                }}
                fullWidth
                maxWidth="sm"
            >
                {/* Close Button */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box />
                    <IconButton size="small" onClick={() => setErrorpopup(false)}>
                        <IconX />
                    </IconButton>
                </Box>

                {/* Error Icon & Title */}
                <DialogTitle id="error-dialog-title" align="center" sx={{ marginTop: -3 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Box
                            sx={{
                                width: 60,
                                height: 60,
                                backgroundColor: "#fff3cd",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "50%",
                                marginBottom: 2,
                            }}
                        >
                            <IconAlertTriangle size={32} color="#ff9800" />
                        </Box>
                    </Box>
                    <Typography variant="h6" fontWeight="bold">
                        Error
                    </Typography>
                </DialogTitle>

                {/* Error Message */}
                <DialogContent>
                    <Typography id="error-dialog-description" align="center">
                        {errorMessage}
                    </Typography>
                </DialogContent>

                {/* Close Button */}
                <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, marginBottom: 1 }}>
                    <Button
                        variant="contained"
                        color="error"
                        sx={{ backgroundColor: "#c63037", border: "none" }}
                        onClick={() => {setErrorpopup(false)
                            setErrorMessage('')
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    );
};

export default Questions;